import React, { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import clsx from 'clsx';
// import  JsonEditorWrapper  from "../../../common/JsonEditorWrapper";
import ReactJSONEditor from "react-jsoneditor-wrapper";



export const ViewDetails = (props: any) => {

    const { t } = props;
    //const dispatch = useAppDispatch();
    const [tab, setTab] = useState('Request JSON');

    const { WebHookRequest, WebHookResponse, TargetURL } = useAppSelector((state) => state.webHookSenderLog);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    function isJSON(str: string) {
        try {
            JSON.parse(str);
            return true;
        } catch (error) {
            return false;
        }
    }
    const handleCloseOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    return (


        <>
            <div className='card-body'>
                <div className='row' >

                    <div className='card card-custom'>
                        <div className='card-header card-header-stretch overflow-auto'>
                            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Request JSON' })}
                                        onClick={() => setTab('Request JSON')}
                                        role='tab'
                                    >
                                        {t('Request JSON')}
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Response JSON' })}
                                        onClick={() => setTab('Response JSON')}
                                        role='tab'
                                    >
                                        {t('Response JSON')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <form className='form'>
                            <div className='card-body'>
                                <div className='tab-content pt-0'>
                                    <div className={clsx('tab-pane', { active: tab === 'Request JSON' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <ReactJSONEditor json={WebHookRequest} name="RequestBody" mode="view" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Response JSON' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                {/* <ReactJSONEditor json={WebHookResponse ? JSON.parse(WebHookResponse) : WebHookResponse} name="ResponseBody" mode="view"    />   */}
                                                {WebHookResponse && (
                                                    <ReactJSONEditor json={isJSON(WebHookResponse) ? JSON.parse(WebHookResponse) : WebHookResponse} name="ResponseBody" mode="view" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>


            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                        </button>
                        <button
                            className="btn btn-light btn-sm me-2"
                            type='button'
                            //id="kt_OffCanvas"

                            data-kt-element='send'
                            onClick={handleCloseOnClickEvent}
                        //onClick={handleResetFiltersOnClickEvent}
                        >
                            {t('Cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </>

    )

}



{/* <div className='card card-custom'>
                <div className='card-header card-header-stretch overflow-auto'>
                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Request JSON' })}
                                onClick={() => setTab('Request JSON')}
                                role='tab'
                            >
                                {t('Request JSON')}
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Response JSON' })}
                                onClick={() => setTab('Response JSON')}
                                role='tab'
                            >
                                {t('Response JSON')}
                            </a>
                        </li>
                    </ul>
                </div>
                
                    <div className='card-body'>
                        <div className='tab-content pt-0'>
                            <div className={clsx('tab-pane', { active: tab === 'Request JSON' })}>
                                <div className='row'>
                                    <div className="col-md-12">
                                        <ReactJSONEditor json={WebHookRequest} name="RequestBody" mode="view" />
                                    </div>
                                </div>
                            </div>
                            <div className={clsx('tab-pane', { active: tab === 'Response JSON' })}>
                                <div className='row'>
                                    <div className="col-md-12">
                                        {WebHookResponse && (
                                            <ReactJSONEditor json={isJSON(WebHookResponse) ? JSON.parse(WebHookResponse) : WebHookResponse} name="ResponseBody" mode="view" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
            </div> */}